import { ARROW_R, LeadNum, Tags } from "./Bits";
import { WORK } from "../data";

export function Work() {
  return (
    <section id="work">
      <LeadNum no="04" label="Selected Work" right="things I've built" />
      <div>
        {WORK.map((w) => (
          <a
            className="work-row"
            href={w.link}
            target="_blank"
            rel="noreferrer"
            key={w.no}
          >
            <div className="fillbg" />
            <div className="work-head">
              <span className="work-no">{w.no}</span>
              <div>
                <div className="work-name">{w.name}</div>
                <div className="work-arrow">{ARROW_R}</div>
              </div>
            </div>
            <div className="work-meta">
              <div className="work-cat">{w.cat}</div>
              <div className="work-desc">{w.d}</div>
              <Tags items={w.tech} />
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
